import { reactive } from 'vue';

// The open/close state of a detail panel, shared as a module singleton (see
// useResults): the cards, the map popup and the panel itself live in separate
// Vue apps, so the state crosses app boundaries through the module that calls
// this factory. Listings and projects each get their own store, because each
// talks to its own detail endpoint.
export const createDetailStore = (api) => {
  const state = reactive({
    isOpen: false,
    // What the trigger already knows (card payload or marker item), so the
    // panel renders its title and status before the fetch resolves.
    seed: null,
    detail: null,
    loading: false,
    error: null
  });

  // Requests are not cancelled; only the newest one may land (see useResults).
  let currentRequest = 0;

  // The element that opened the panel gets focus back on close (WCAG 2.4.3).
  let triggerElement = null;

  const open = (seed) => {
    triggerElement = document.activeElement instanceof HTMLElement ? document.activeElement : null;
    currentRequest += 1;
    const token = currentRequest;

    state.isOpen = true;
    state.seed = seed || null;
    state.detail = null;
    state.error = null;
    state.loading = true;

    api.detail(seed.id).then(
      (payload) => {
        if (token !== currentRequest) return;
        state.detail = payload;
        state.loading = false;
      },
      (error) => {
        if (token !== currentRequest) return;
        state.error = error.message || 'Detail request failed';
        state.loading = false;
      }
    );
  };

  const close = () => {
    currentRequest += 1;
    state.isOpen = false;
    state.seed = null;
    state.detail = null;
    state.loading = false;
    state.error = null;

    if (triggerElement) {
      triggerElement.focus();
      triggerElement = null;
    }
  };

  return { state, open, close };
};
